import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-admin';
import { FieldProps } from '../../types';

/**
 * Component to display an order field in the charge list with a link to the order's detail page
 * Uses the embedded order object from the charge API response
 */
const ChargeOrderField: React.FC<FieldProps<any>> = ({
    record,
    link = 'show',
}) => {
    if (!record) return null;

    // Handle both nested order object and direct orderId
    const orderId = record.order?.id || record.orderId;

    if (!orderId) return <span>-</span>;

    return link ? (
        <Link to={`/orders/${orderId}/show`}>{orderId}</Link>
    ) : (
        <span>{orderId}</span>
    );
};

ChargeOrderField.propTypes = {
    record: PropTypes.object,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    label: PropTypes.string,
};

ChargeOrderField.defaultProps = {
    addLabel: true,
    label: 'Order',
};

export default ChargeOrderField;
